import { Rule, RuleObject } from "rc-field-form/lib/interface";
import { Nullable } from "../models/Common";

export type AntdFormValidations = Rule[];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AntdFormValues = Record<string, any>;

export type AntdRulesObject<FormValues extends AntdFormValues> = Record<
  keyof FormValues,
  AntdFormValidations
>;

export type AntdFormValidationObject<FormValues extends AntdFormValues> = {
  getFieldValidation: (
    field: keyof FormValues
  ) => { rules: AntdFormValidations };
};

export const generateFormValidations = <FormValues extends AntdFormValues>(
  rules: Partial<AntdRulesObject<FormValues>>
): {
  getFieldValidation: (
    field: keyof FormValues
  ) => { rules: AntdFormValidations };
} => {
  const enclosedCopy: Partial<AntdRulesObject<FormValues>> = { ...rules };
  return {
    getFieldValidation: (
      field: keyof FormValues
    ): { rules: AntdFormValidations } => ({ rules: enclosedCopy[field] ?? [] }),
  };
};

export type CustomValidator = <T extends unknown>(
  rule: RuleObject,
  value: T,
  callback: (error?: Nullable<string>) => void
) => void;

export type CustomValidatorsObject = Record<string, CustomValidator>;
